var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateMyIdeas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", {
    id: "light-bulb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "light-top"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.48,5.75c-12.83,1.93-21.49,13.67-19.55,26.5,1.19,7.89,6.18,14.21,12.7,17.26l1.14,7.57c.25,1.64,1.81,3.09,3.79,2.79l19.74-2.98c1.97-.3,3.04-2.14,2.79-3.79l-1.14-7.57c5.28-5.17,8.18-12.67,7.04-20.24-1.93-12.83-13.67-21.49-26.5-19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.04,60.53c-.88,0-1.72-.29-2.41-.84-.79-.63-1.33-1.54-1.47-2.52l-1.09-7.24c-6.83-3.32-11.58-9.87-12.74-17.59-.96-6.37,.59-12.69,4.35-17.8,3.77-5.11,9.35-8.45,15.72-9.41,13.26-2,25.21,6.82,27.21,20.07,1.11,7.37-1.5,15.03-6.99,20.55l1.09,7.25c.28,1.88-.9,4.13-3.31,4.49l-19.74,2.98c-.2,.03-.41,.05-.61,.05ZM44.12,6.1c-1.17,0-2.35,.09-3.54,.27-6.04,.91-11.33,4.08-14.9,8.92-3.57,4.84-5.04,10.83-4.13,16.87,1.12,7.41,5.73,13.69,12.34,16.79l.3,.14,1.19,7.89c.1,.67,.47,1.3,1.02,1.73,.58,.46,1.31,.65,2.06,.54l19.74-2.98c1.65-.25,2.46-1.79,2.27-3.08l-1.19-7.88,.23-.22c5.36-5.26,7.93-12.62,6.86-19.7-1.72-11.37-11.16-19.3-22.25-19.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "light-bottom"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.04,69.73c.25,1.64,1.81,3.09,3.79,2.79l13.16-1.98c1.97-.3,3.04-2.14,2.79-3.79l-.5-3.29-19.74,2.98,.5,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.31,73.19c-.88,0-1.72-.29-2.41-.84-.79-.63-1.33-1.54-1.47-2.52l-.59-3.9,20.97-3.16,.59,3.9c.28,1.88-.9,4.13-3.32,4.49l-13.16,1.98c-.2,.03-.41,.05-.61,.05Zm-3.06-6.22l.4,2.67c.1,.67,.47,1.3,1.02,1.73,.58,.46,1.31,.65,2.06,.54l13.16-1.98c1.65-.25,2.47-1.79,2.27-3.08l-.4-2.67-18.5,2.79Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "smile"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.04,41.84c-2.61,0-5.15-.83-7.29-2.41-2.65-1.95-4.38-4.82-4.87-8.08l1.23-.19c.44,2.93,2,5.5,4.38,7.26,2.38,1.76,5.31,2.48,8.23,2.04,6.04-.91,10.21-6.57,9.3-12.61l1.23-.19c1.01,6.72-3.63,13.01-10.35,14.02-.62,.09-1.25,.14-1.86,.14Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateMyIdeas);
export default __webpack_public_path__ + "static/media/illustration_empty-state-my-ideas.630e6882c49d32d2321a1fa17cea8340.svg";
export { ForwardRef as ReactComponent };